exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1N2fTvCX4P6YloT6A2gJzM{padding:24px 24px 14px}", ""]);

// exports
exports.locals = {
	"root": "_2njtOPa2UaRkTIjL9XtbSN",
	"formContainer": "_1N2fTvCX4P6YloT6A2gJzM"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/postcss-loader!./containers/edit-user-drawer.css
 ** module id = 1024
 ** module chunks = 0
 **/